const ANCESTOR_PAINTING_PALETTE = [
    '#A6192E', '#0072B2', '#D55E00', '#009E73', '#CC79A7', '#E69F00',
    '#5B2A86', '#56B4E9', '#8F6B00', '#006D77', '#C44E52', '#4E79A7',
    '#59A14F', '#F28E2B', '#B07AA1', '#9C755F', '#2F4B7C', '#D45087',
    '#00A6A6', '#8C564B', '#9467BD', '#BCBD22', '#17BECF', '#7F7F7F',
    '#B12A90', '#1B9E77', '#D95F02', '#7570B3', '#E7298A', '#66A61E',
    '#E6AB02', '#A6761D', '#1F78B4', '#B2DF8A', '#FB9A99', '#CAB2D6',
    '#FDBF6F', '#6A3D9A', '#B15928', '#2A9D8F', '#E76F51', '#264653',
    '#F4A261', '#8AB17D', '#6D597A', '#B56576', '#355070', '#43AA8B',
    '#F94144', '#F3722C', '#F8961E', '#90BE6D', '#577590', '#277DA1',
    '#9B5DE5', '#F15BB5', '#00BBF9', '#00F5D4', '#B5838D', '#6D6875',
];

export function colorForAncestorKey(ancestorKey) {
    const key = String(ancestorKey || 'unknown');
    let hash = 0;
    for (let index = 0; index < key.length; index += 1) {
        hash = ((hash << 5) - hash) + key.charCodeAt(index);
        hash |= 0;
    }
    return ANCESTOR_PAINTING_PALETTE[Math.abs(hash) % ANCESTOR_PAINTING_PALETTE.length];
}
